export default __webpack_public_path__ + "static/contribute-b50a95992101e912679eee3d9ac6fa9d.webp";